export default __webpack_public_path__ + "fm-logo-dark.png";